import { getCookieContent, getCookieValue } from './cookies';

export default function getVisitorId(): string {
  const visitorCookie = getCookieContent('KmxVisitor_0');
  return visitorCookie ? getCookieValue(visitorCookie, 'VisitorID') : '';
}
